import textServices from 'services/text-services'
import { NEIGHBARS_ASSETS } from '../constants'

const SuccessSection = () => {
  return (
    <section className="neighbars__success">
      <div className="neighbars__success-dome">
        <div className="neighbars__success-card">
          <img
            className="neighbars__success-check"
            src={`${NEIGHBARS_ASSETS}/neighbars-success-check.png`}
            alt=""
            aria-hidden="true"
          />
          <h2 className="neighbars__success-title">
            {textServices.findByText('neighbars/success/title', '¡Ya estás participando!')}
          </h2>
          <p className="neighbars__success-text">
            {textServices.findByText(
              'neighbars/success/text',
              'Nos pondremos en contacto contigo por correo en caso de que quedes entre los ganadores.'
            )}
          </p>
        </div>
      </div>
    </section>
  )
}

export default SuccessSection
